import React, {ReactNode, useCallback} from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Offer} from '../../../types/partnersApi/types'

interface OfferInteractionProps {
  // Add props when implementing tracking
  children: ReactNode
  offer: Offer
  onClick?: (offer: Offer) => void
}

const offerLinkWrapperBaseStyles = () => css`
  display: block;
  width: 100%;
  max-height: 150px;
  text-decoration: none;

  /* TODO: (@search / @atlas) - relook line-height override when removing the default line-height on anchors */
  line-height: 1;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`
const OfferLinkWrapper = styled('a')(offerLinkWrapperBaseStyles)

/**
 * A wrapper component that handles all interactions on offers
 * Avoid adding styling here, it should transparently add interactivity
 */
export const OfferInteraction = ({
  children,
  offer,
  onClick
}: OfferInteractionProps) => {
  const redirectLink = offer.url
  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()

      // Handle click & trigger any side-effects in consumer
      onClick?.(offer)
    },
    [onClick, offer]
  )

  return (
    <OfferLinkWrapper
      href={redirectLink}
      target={'_blank'}
      onClick={handleClick}
    >
      {children}
    </OfferLinkWrapper>
  )
}
